export default "__VITE_ASSET__q5gnp$JL__"